export enum ProgressEnum {
  risk = 'risk', //high_risk
  error = 'error', //very_high_risk
  warning = 'warning', //warning
  success = 'success', //low
}
